export default "__VITE_ASSET__BtFoKNCk__"